import { Button, Input, Radio, Select, Tooltip } from 'antd';
import { LayoutGrid, List, Plus, ScanLine, Search } from 'lucide-react';

export type ViewMode = 'card' | 'table';
export type StatusFilter = 'all' | 'enabled' | 'disabled';

interface ChannelAccountToolbarProps {
  /** 当前类型显示名（如「飞书」），用于计数文案 */
  activeLabel: string;
  count: number;
  search: string;
  onSearchChange: (v: string) => void;
  statusFilter: StatusFilter;
  onStatusFilterChange: (v: StatusFilter) => void;
  viewMode: ViewMode;
  onViewModeChange: (v: ViewMode) => void;
  onCreate?: () => void;
  /** 飞书一键扫码创建回调；不传则不显示按钮 */
  onFeishuQuickCreate?: () => void;
  /** WebSocket 分区显示「绑定 Agent」筛选位（本轮预留，不接逻辑） */
  showBoundAgentFilter?: boolean;
  boundAgentFilter?: string;
  onBoundAgentFilterChange?: (v: string | undefined) => void;
  boundAgentOptions?: { value: string; label: string }[];
}

/** 工具栏：计数 · 搜索 · 状态筛选 ·（WebSocket）绑定 Agent 筛选 · 视图切换 · 新建。 */
export default function ChannelAccountToolbar({
  activeLabel,
  count,
  search,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  viewMode,
  onViewModeChange,
  onCreate,
  onFeishuQuickCreate,
  showBoundAgentFilter = false,
  boundAgentFilter,
  onBoundAgentFilterChange,
  boundAgentOptions = [],
}: ChannelAccountToolbarProps) {
  return (
    <div className="cha-toolbar">
      <span className="count">
        {activeLabel} · 共 {count} 个
      </span>
      <Input
        placeholder="搜索名称 / ID"
        allowClear
        prefix={<Search size={14} />}
        style={{ width: 150 }}
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
      />
      <Select
        value={statusFilter}
        style={{ width: 120 }}
        onChange={onStatusFilterChange}
        options={[
          { value: 'all', label: '全部状态' },
          { value: 'enabled', label: '已启用' },
          { value: 'disabled', label: '已停用' },
        ]}
      />
      {showBoundAgentFilter && (
        <Select
          value={boundAgentFilter}
          allowClear
          showSearch
          optionFilterProp="label"
          placeholder="绑定 Agent"
          style={{ width: 180 }}
          options={boundAgentOptions}
          onChange={onBoundAgentFilterChange}
        />
      )}
      <div style={{ flex: 1 }} />
      <Radio.Group
        value={viewMode}
        onChange={(e) => onViewModeChange(e.target.value as ViewMode)}
        optionType="button"
        buttonStyle="solid"
        style={{ minWidth: 95 }}
      >
        <Tooltip title="卡片视图">
          <Radio.Button value="card" style={{ display: 'inline-flex', alignItems: 'center' }}>
            <LayoutGrid size={15} />
          </Radio.Button>
        </Tooltip>
        <Tooltip title="表格视图">
          <Radio.Button value="table" style={{ display: 'inline-flex', alignItems: 'center' }}>
            <List size={15} />
          </Radio.Button>
        </Tooltip>
      </Radio.Group>
      {onFeishuQuickCreate && (
        <Button icon={<ScanLine size={14} />} onClick={onFeishuQuickCreate}>
          扫码创建
        </Button>
      )}
      {onCreate && (
        <Button type="primary" icon={<Plus size={14} />} onClick={onCreate}>
          新建账号
        </Button>
      )}
    </div>
  );
}
